import script from "./FeaturedVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturedVouchersPage.vue?vue&type=style&index=0&id=5e8a1e87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8a1e87"]])

export default __exports__